/**
 * QuaggaJSの設定
 * @see {link https://github.com/serratus/quaggaJS#configuration | quaggaJS}
 */

export const QuaggaConfig = {
	inputStream: {
		name: 'Live',
		type: 'LiveStream',
		target: null,
		constraints: {
			width: { min: 640 },
			height: { min: 480 },
			facingMode: 'environment'
			// aspectRatio: { min: 1, max: 2 }
		}
	},
	area: {
		top: '0',
		right: '0',
		left: '0',
		bottom: '0'
	},
	decoder: {
		readers: ['ean_reader', 'ean_8_reader'],
		// readers: ["code_128_reader"],
		debug: {
			showCanvas: true,
			showPatches: true,
			showFoundPatches: true,
			showSkeleton: true,
			showLabels: true,
			showPatchLabels: true,
			showRemainingPatchLabels: true,
			boxFromPatches: {
				showTransformed: true,
				showTransformedBox: true,
				showBB: true
			}
		}
	}
}
